import Prices,{IpPrices} from './Prices'
import Device from './Device'
import DeviceTable from './DeviceTable'
import PayMethod from './PayMethod'
import Bottom from './Bottom'

const NewMachine = {
    Prices: Prices,
    IpPrices: IpPrices,
    Device: Device,
    DeviceTable,
    PayMethod,
    Bottom
}

export default NewMachine
